import { defineMessages } from 'react-intl';

// Main route
const merchantScope = 't.page.merchant';

// Global scope
const globalScope = 't.global';

// Navigation
const navigationScope = 't.component.PortalAppNavigation';

// Global errors
const globalErrorsScope = 't.global.error';

export default defineMessages({
	// Merchant Scope
	successfullyDelete: {
		id: `${merchantScope}.successfullyDelete`,
		defaultMessage: 'Merchant eliminato con successo',
	},
	failureDelete: {
		id: `${merchantScope}.failureDelete`,
		defaultMessage: 'Eliminazione merchant fallita',
	},
	deleteSubtitle: {
		id: `${merchantScope}.deleteSubtitle`,
		defaultMessage: 'del merchant',
	},
	detailTitle: {
		id: `${merchantScope}.detailTitle`,
		defaultMessage: 'Dettaglio merchant',
	},
	merchantEditing: {
		id: `${merchantScope}.merchantEditing`,
		defaultMessage: 'Modifica merchant',
	},
	merchantCreation: {
		id: `${merchantScope}.merchantCreation`,
		defaultMessage: 'Crea merchant',
	},
	newMerchantTitle: {
		id: `${merchantScope}.newMerchantTitle`,
		defaultMessage: 'Inserisci i dati del merchant',
	},
	merchantCreatedSuccessfully: {
		id: `${merchantScope}.merchantCreatedSuccessfully`,
		defaultMessage: 'Merchant creato con successo',
	},
	merchantNotCreatedSuccessfully: {
		id: `${merchantScope}.merchantNotCreatedSuccessfully`,
		defaultMessage: 'Creazione merchant fallita',
	},
	merchantUpdatedSuccessfully: {
		id: `${merchantScope}.merchantUpdatedSuccessfully`,
		defaultMessage: 'Merchant modificato con successo',
	},
	merchantUpdatedNotSuccessfully: {
		id: `${merchantScope}.merchantUpdatedNotSuccessfully`,
		defaultMessage: 'Modifica merchant fallita',
	},
	goBackModalButton: {
		id: `${merchantScope}.goBackModalButton`,
		defaultMessage: "Torna all'elenco merchant",
	},

	// Navigation Scope
	pageTitle: {
		id: `${navigationScope}.merchant.merchantList`,
		defaultMessage: 'Elenco Merchant',
	},
	newMerchant: {
		id: `${navigationScope}.merchant.merchantManagement`,
		defaultMessage: 'Crea Merchant',
	},

	// Global Scope
	cap: {
		id: `${globalScope}.cap`,
		defaultMessage: 'Cap',
	},
	address: {
		id: `${globalScope}.address`,
		defaultMessage: 'Indirizzo',
	},
	county: {
		id: `${globalScope}.county`,
		defaultMessage: 'Provincia',
	},
	country: {
		id: `${globalScope}.country`,
		defaultMessage: 'Nazione',
	},
	personalData: {
		id: `${globalScope}.personalData`,
		defaultMessage: 'Dati anagrafici',
	},
	id: {
		id: `${globalScope}.id`,
		defaultMessage: 'ID',
	},
	name: {
		id: `${globalScope}.name`,
	},
	creationDate: {
		id: `${globalScope}.creationDate`,
		defaultMessage: 'Data creazione',
	},
	lastUpdateDate: {
		id: `${globalScope}.lastUpdateDate`,
		defaultMessage: 'Data ultimo aggiornamento',
	},
	abortLabelButton: {
		id: `${globalScope}.abort`,
		defaultMessage: 'Annulla',
	},
	createLabelButton: {
		id: `${globalScope}.create`,
		defaultMessage: 'Crea',
	},
	confirmLabelButton: {
		id: `${globalScope}.confirm`,
		defaultMessage: 'Conferma',
	},
	saveLabelButton: {
		id: `${globalScope}.save`,
		defaultMessage: 'Salva',
	},
	emptyString: {
		id: `${globalScope}.emptyString`,
		defaultMessage: ' ',
	},
	edit: {
		id: `${globalScope}.edit`,
		defaultMessage: 'Modifica',
	},
	warning: {
		id: `${globalScope}.warning`,
		defaultMessage: 'Attenzione',
	},
	subtitleDelete: {
		id: `${globalScope}.subtitleDelete`,
		defaultMessage: 'Sei sicuro di voler procedere alla cancellazione {element}?',
	},
	invalidDate: {
		id: `${globalScope}.error.invalidDate`,
		defaultMessage: 'Data non valida',
	},
	theSecondDateIsMinorThanFirst: {
		id: `${globalScope}.error.theSecondDateIsMinorThanFirst`,
		defaultMessage: 'Data di fine troppo piccola',
	},
	fillFirstDateToContinueValidation: {
		id: `${globalScope}.error.fillFirstDateToContinueValidation`,
		defaultMessage: "Data d'inizio mancante",
	},
	externalId: {
		id: `${globalScope}.externalId`,
		defaultMessage: 'ID Esterno',
	},
	group: {
		id: `${globalScope}.group`,
		defaultMessage: 'Gruppo',
	},
	reportXls: {
		id: `${globalScope}.reportXls`,
		defaultMessage: 'Report XLS',
	},
	city: {
		id: `${globalScope}.city`,
		defaultMessage: 'Città',
	},
	fieldRequested: {
		id: `${globalErrorsScope}.fieldRequested`,
		defaultMessage: 'Campo obbligatorio',
	},
});
